module.exports = __webpack_public_path__ + "img/andorra.abb4ef0d.svg";